import type { ReactNode } from 'react';

type Tom = 'neutro' | 'destaque' | 'marca' | 'aviso' | 'ok';

const TONS: Record<Tom, string> = {
  neutro: 'border-borda-forte text-apagado',
  destaque: 'border-transparent bg-destaque-fundo text-destaque-texto',
  marca: 'border-transparent bg-marca text-sobre-marca',
  aviso: 'border-aviso/40 text-aviso',
  ok: 'border-ok/40 text-ok',
};

/** Etiqueta de canto pequeno (nao e pilula): estado ou classe ao lado do nome. */
export function Etiqueta({ children, tom = 'neutro' }: { children: ReactNode; tom?: Tom }) {
  return (
    <span
      className={`inline-flex h-5 items-center rounded-(--radius-etiqueta) border px-1.5 text-xs font-semibold tracking-wide whitespace-nowrap uppercase ${TONS[tom]}`}
    >
      {children}
    </span>
  );
}
